import gsap, { Expo, Power2, Power4 } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
// import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { GetBy } from '../_app/cuchillo/core/Element';
import { isTouch } from '../_app/cuchillo/core/Basics';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { SplitText } from 'gsap/all';
import { Functions } from '../_app/cuchillo/utils/Functions';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { Maths } from '../_app/cuchillo/utils/Maths';

const INTERVAL = 4000;

class ScrollItem__StickyCard extends Scroll_Item {

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.onMove = () => {
            
        };
    }
}

Scroll._registerClass('StickyCard', ScrollItem__StickyCard);

export default ScrollItem__StickyCard;
